import * as React from "react"
import { TextStyle, TouchableOpacity, View, ViewStyle } from "react-native"
import { Text } from "../text/text"
import { color, spacing } from "../../theme"
import { CheckboxProps } from "./checkbox.props"
import { CheckIcon } from "native-base"

const ROOT: ViewStyle = {
  flexDirection: "row",
  paddingVertical: spacing[1],
  alignSelf: "flex-start",
  alignItems: "flex-start"
}

const DIMENSIONS = { width: 16, height: 16 }

const OUTLINE: ViewStyle = {
  ...DIMENSIONS,
  marginTop: 5, // finicky and will depend on font/line-height/baseline/weather
  justifyContent: "center",
  alignItems: "center",
  borderWidth: 1,
  borderColor: color.primary,
  borderRadius: 3,
}

const FILL: ViewStyle = {
  width: DIMENSIONS.width,
  height: DIMENSIONS.height,
  backgroundColor: color.primary,
  borderRadius: 3,
  alignItems: 'center',
  justifyContent: 'center'
}

const ADD_ON = (color): ViewStyle => ({
  width: 25,
  height: 8,
  alignSelf: 'center',
  justifyContent: 'center',
  backgroundColor: color,
  marginLeft: 5,
  marginTop: 2
})

const LABEL: TextStyle = {
  paddingLeft: spacing[2]
}

export function Checkbox(props: CheckboxProps) {
  const { colorScheme } = props
  const numberOfLines = props.multiline ? 0 : 1

  const rootStyle = [ROOT, props.style]
  const outlineStyle = [OUTLINE, props.outlineStyle]
  const fillStyle = [FILL, props.fillStyle]
  const labelStyle = [LABEL, props.labelStyle]

  const onPress = props.onToggle ? () => props.onToggle && props.onToggle(!props.value) : null

  return (
    <TouchableOpacity
      activeOpacity={1}
      disabled={!props.onToggle || props.disabled}
      onPress={onPress}
      style={rootStyle}
    >
      {/* <View style={outlineStyle}>{props.value && <View style={fillStyle} />}</View> */}
      <View style={outlineStyle}>{props.value && <View style={fillStyle}><CheckIcon size={2.5} color={color.palette.white} /></View>}</View>
      {props.addOn && <View style={ADD_ON(props.addOnColor)} />}
      <Text text={props.text} tx={props.tx} numberOfLines={numberOfLines} mt="2px" style={labelStyle} colorScheme={colorScheme} mr="6px" preset={props.labelPreset} />
    </TouchableOpacity>
  )
}
